// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isValidEnvVarValue(envVarValue: any): envVarValue is string {
  return typeof envVarValue === 'string' && envVarValue.length >= 1;
}
